import React from "react";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import "react-data-grid/lib/styles.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import Container from "react-bootstrap/Container";
import Footer from "./components/footer";
import { ToastContainer } from "react-toastify";
import AtsRouter from "./components/atsRouter";
import { withQueryParams } from "./common/queryParams";

class App extends React.Component {
  state = {};

  render() {
    const { embed } = this.props.queryParams;

    return (
      <React.Fragment>
        <main>
          <Container fluid className="g-0">
            <ToastContainer />
            <AtsRouter />
          </Container>
          {!embed && <div className="m-5">&nbsp;</div>}
        </main>
        {!embed && (
          <footer>
            <Footer />
          </footer>
        )}
      </React.Fragment>
    );
  }
}

export default withQueryParams(App);
